import React, { useEffect, useState } from 'react'
import ReactModal from 'react-modal'
import CloseBtn from '../../buttons/CloseBtn'
import { Form } from 'react-bootstrap'
import RequieredInputs from '../../common/RequiredInputs'
import { eventosActions } from '../../../actions/eventosActions'
import { businessunitsActions } from '../../../actions/businessunitsActions'
import { specialtiesActions } from '../../../actions/specialtiesActions'
import { departamentsActions } from '../../../actions/departamentsActions'
import { hospitalsActions } from '../../../actions/hospitalsActions'
import { positionsActions } from '../../../actions/positionsActions'
import { BusinessUnitMultiSelect } from '../../fields'
import DateField from '../../fields/DateField/DateField'
import { useDispatch, useSelector } from 'react-redux'
import { formatDateForInput } from '../../../utils/date'
import FooterLGPD from '../../common/FooterLGPD'
import _ from 'lodash'
import HospitalSelect from '../../fields/HospitalSelect/HospitalSelect'

const ContactModal = ({
  modalIsOpen,
  closeModal,
  inputs,
  handleChange,
  handleSubmit,
  validateForm,
  textBtn,
  isEdit = true,
}) => {
  const dispatch = useDispatch()
  const getAllEventos = () => dispatch(eventosActions.getAllEventos())
  const getAllBusinessUnits = () =>
    dispatch(businessunitsActions.getAllBusinessUnits())
  const getAllSpecialties = () =>
    dispatch(specialtiesActions.getAllSpecialties(0))
  const getAllDepartaments = () =>
    dispatch(departamentsActions.getAllDepartaments())
  const getAllHospitals = () => dispatch(hospitalsActions.getAllHospitals())
  const getAllPositions = () => dispatch(positionsActions.getAllPositions())
  // Selectors
  const specialties = useSelector((state) => state.specialties)
  const departaments = useSelector((state) => state.departaments)
  const hospitals = useSelector((state) => state.hospitals)
  const positions = useSelector((state) => state.positions)

  const [eventos, setEventos] = useState([])
  const [localBusinessUnits, setLocalBusinessUnits] = useState([])
  const [isCheckedLGPD, setIsCheckedLGPD] = useState(false)

  // Sincronizar unidades de negocio locales con inputs cuando cambien
  useEffect(() => {
    setLocalBusinessUnits(inputs.businessUnits || [])
  }, [inputs.businessUnits])

  // Sincronizar LGPD con inputs si existe
  useEffect(() => {
    if (inputs.isCheckedLGPD !== undefined) {
      setIsCheckedLGPD(inputs.isCheckedLGPD)
    }
  }, [inputs.isCheckedLGPD])

  useEffect(() => {
    retrieveEventos()
    getAllBusinessUnits()
    getAllSpecialties()
    getAllDepartaments()
    getAllHospitals()
    getAllPositions()
  }, [])

  const retrieveEventos = async () => {
    const response = await getAllEventos()
    if (response && response.payload) setEventos(response.payload || [])
  }

  const customStyles = {
    content: {
      width: '90%',
      maxHeight: '90vh',
      padding: '25px',
      overflow: 'auto',
      zIndex: 2,
    },
  }

  // Asegurar que el BusinessUnitMultiSelect se renderice correctamente
  const businessUnitContainerStyle = {
    position: 'relative',
    zIndex: 1000,
  }

  // Títulos dinámicos según el modo
  const modalTitle = isEdit ? 'Editar contacto' : 'Alta nuevo contacto'
  const contentLabel = isEdit ? 'Editar contacto' : 'Alta nuevo contacto'

  // Función personalizada para manejar cambios de fecha
  const handleDateChange = (e) => {
    const { name, value } = e.target
    if (name === 'fechaNacimiento') {
      // Convertir la fecha del input (YYYY-MM-DD) al formato esperado por el backend
      const formattedDate = value
        ? (() => {
            const [year, month, day] = value.split('-')
            return `${day}/${month}/${year} 00:00:00`
          })()
        : ''

      handleChange({
        target: {
          name,
          value: formattedDate,
        },
      })
    } else {
      handleChange(e)
    }
  }

  // Función para manejar cambios en las unidades de negocio
  const handleBusinessUnitsChange = (selectedIds) => {
    setLocalBusinessUnits(selectedIds)

    // Actualizar el estado del formulario
    const syntheticEvent = {
      target: {
        name: 'businessUnits',
        value: selectedIds,
      },
    }
    handleChange(syntheticEvent)
  }

  // Función para manejar aceptación de LGPD
  const handleAcceptLGPD = (e) => {
    const checked = e.target.checked
    setIsCheckedLGPD(checked)

    // Actualizar el estado del formulario
    const syntheticEvent = {
      target: {
        name: 'isCheckedLGPD',
        value: checked,
      },
    }
    handleChange(syntheticEvent)
  }

  // Ordenar datos para los selects
  const sortedSpecialties = _.orderBy(specialties, ['nombre'], ['asc'])
  const sortedDepartaments = _.orderBy(departaments, ['nombre'], ['asc'])
  const sortedHospitals = _.orderBy(hospitals, ['nombre'], ['asc'])
  const sortedPositions = _.orderBy(positions, ['nombre'], ['asc'])

  return (
    <ReactModal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      contentLabel={contentLabel}
      className='custom-modal'
      style={customStyles}
    >
      <span className='custom-modal__close close-btn' onClick={closeModal}>
        <CloseBtn />
      </span>
      <h4 className='custom-modal__title'>{modalTitle}</h4>
      <Form onSubmit={handleSubmit} className='modal__form'>
        <div className='modal-form-container'>
          {/* Nombre y Observaciones */}
          <div className='modal-form-field modal-form-field--medium'>
            <Form.Group size='lg'>
              <Form.Label className='form__labels'>
                Nombre y apellido <RequieredInputs />
              </Form.Label>
              <Form.Control
                className='user-input form__input'
                type='text'
                name='nombre'
                value={inputs.nombre}
                onChange={handleChange}
                placeholder='Nombre y apellido'
              />
            </Form.Group>
          </div>
          <div className='modal-form-field modal-form-field--medium'>
            <Form.Group size='lg'>
              <Form.Label className='form__labels'>Observaciones</Form.Label>
              <Form.Control
                className='user-input form__input'
                type='text'
                name='observaciones'
                value={inputs.observaciones}
                onChange={handleChange}
                placeholder='Observaciones'
              />
            </Form.Group>
          </div>

          <div className='modal-form-field modal-form-field--medium'>
            <Form.Group size='lg'>
              <Form.Label className='form__labels'>
                Email <RequieredInputs />
              </Form.Label>
              <Form.Control
                className='user-input form__input'
                type='email'
                name='email'
                value={inputs.email}
                onChange={handleChange}
                placeholder='Email'
              />
            </Form.Group>
          </div>
          <div className='modal-form-field modal-form-field--medium'>
            <Form.Group size='lg'>
              <Form.Label className='form__labels'>
                Teléfono
              </Form.Label>
              <Form.Control
                className='user-input form__input'
                type='text'
                name='telf'
                minLength='9'
                value={inputs.telf}
                onChange={handleChange}
                placeholder='Teléfono'
              />
            </Form.Group>
          </div>
          {/* <div className='modal-form-field modal-form-field--small'>
            <Form.Group size='lg'>
              <Form.Label className='form__labels'>Cumpleaños</Form.Label>
              <DateField
                name='fechaNacimiento'
                value={inputs.fechaNacimiento || ''}
                onChange={handleDateChange}
                required={false}
                disabled={false}
              />
            </Form.Group>
          </div> */}

          {/* Hospital, Departamento, Especialidad */}
          <div className='modal-form-field modal-form-field--medium'>
            <HospitalSelect
              hospitals={sortedHospitals}
              inputs={inputs}
              handleChange={handleChange}
              name='id_Hospitales'
            />
          </div>
          <div className='modal-form-field modal-form-field--medium'>
            <Form.Group size='lg'>
              <Form.Label className='form__labels'>
                Departamento
                <RequieredInputs />
              </Form.Label>
              <Form.Control
                as='select'
                className='user-input form__input'
                name='id_Departamentos'
                onChange={handleChange}
                value={
                  inputs?.id_Departamentos || inputs?.id_Departamentos || ''
                }
              >
                <option value=''>Seleccionar Departamento</option>
                {sortedDepartaments.map((departament) => (
                  <option
                    key={departament?.id_TipoDepartamento}
                    value={departament?.id_TipoDepartamento}
                  >
                    {departament.nombre}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </div>
          <div className='modal-form-field modal-form-field--medium'>
            <Form.Group size='lg'>
              <Form.Label className='form__labels'>
                Especialidad <RequieredInputs />
              </Form.Label>
              <Form.Control
                as='select'
                className='user-input form__input'
                name='id_Especialidades'
                onChange={handleChange}
                value={
                  inputs?.id_Especialidades || inputs?.id_Especialidades || ''
                }
              >
                <option value=''>Seleccionar Especialidad</option>
                {sortedSpecialties.map((specialty) => (
                  <option
                    key={specialty.id_TipoEspecialidad}
                    value={specialty.id_TipoEspecialidad}
                  >
                    {specialty.nombre}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </div>
          <div className='modal-form-field modal-form-field--medium'>
            <Form.Group size='lg'>
              <Form.Label className='form__labels'>
                Cargo
                <RequieredInputs />
              </Form.Label>
              <Form.Control
                as='select'
                className='user-input form__input'
                name='id_TipoCargo'
                onChange={handleChange}
                value={inputs?.id_TipoCargo || inputs?.id_TipoCargo || ''}
              >
                <option value=''>Seleccionar Cargo</option>
                {sortedPositions.map((position) => (
                  <option
                    key={position.id_TipoCargo}
                    value={position.id_TipoCargo}
                  >
                    {position.nombre}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </div>

          {/* Evento relacionado y Unidades de Negocio */}
          <div className='modal-form-field modal-form-field--medium'>
            <Form.Group size='lg'>
              <Form.Label className='form__labels'>
                Evento relacionado
              </Form.Label>
              <Form.Control
                as='select'
                className='user-input form__input'
                name='id_Evento'
                onChange={handleChange}
                value={inputs.id_Evento || ''}
              >
                <option value={''}>Seleccionar un Evento</option>
                {eventos
                  ? eventos.map((evento) => (
                      <option key={evento.id_Evento} value={evento.id_Evento}>
                        {evento.nombre}
                      </option>
                    ))
                  : null}
              </Form.Control>
            </Form.Group>
          </div>
          <div
            className='modal-form-field modal-form-field--component'
            style={businessUnitContainerStyle}
          >
            <BusinessUnitMultiSelect
              value={localBusinessUnits}
              required
              onChange={handleBusinessUnitsChange}
            />
          </div>
        </div>
        {!isEdit && <FooterLGPD handleAcceptLGPD={handleAcceptLGPD} />}

        <div className='modal-form-actions'>
          <button
            onClick={handleSubmit}
            disabled={!validateForm()}
            className='btn save create'
          >
            {textBtn}
          </button>
        </div>
      </Form>
    </ReactModal>
  )
}

ReactModal.setAppElement('#root')
export default ContactModal
